/*
         * @ngdoc function
         * @name ePay.Model:Session_AppleAddressModel
         * @description
         * Model
         */

export class Session_AppleAddressModel {
  addressLine: string[] | null | undefined;
  city: string | null | undefined;
  country: string | null | undefined;
  dependentLocality: string | null | undefined;
  languageCode: string | null | undefined;
  organization: string | null | undefined;
  phone: string | null | undefined;
  postalCode: string | null | undefined;
  recipient: string | null | undefined;
  region: string | null | undefined;
  sortingCode: string | null | undefined;

	constructor(
		addressLine?: string[], 
		city?: string, 
		country?: string, 
		dependentLocality?: string, 
		languageCode?: string, 
		organization?: string, 
		phone?: string, 
		postalCode?: string, 
		recipient?: string, 
		region?: string, 
		sortingCode?: string
	) {
		this.addressLine = addressLine || [];
		this.city = city || null;
		this.country = country || null;
		this.dependentLocality = dependentLocality || null;
		this.languageCode = languageCode || null;
		this.organization = organization || null;
		this.phone = phone || null;
		this.postalCode = postalCode || null;
		this.recipient = recipient || null;
		this.region = region || null;
		this.sortingCode = sortingCode || null;
	}
}
